export const formControlStyle = {
  backgroundColor: "#ffffff",
  border: "1.5px solid #b783cc",
  borderRadius: "5px",
  paddingTop: "0px",
  fontFamily: "'Archivo',sans-serif",
  "& .MuiInputBase-input": {
    fontFamily: "'Archivo',sans-serif",
  },
};

export const inputLableStyle = {
  fontSize: "13px",
  lineHeight: "20px",
  color: "#1f1f1f",
  fontWeight: 600,
  fontFamily: "'Archivo',sans-serif",
};

export const outlineInputStyle = {
  fontFamily: "'Archivo',sans-serif",
  color: "#1f1f1f",
};

export const radioLabelStyle = {
  fontWeight: 500,
  lineHeight: "24px",
  fontFamily: "'Archivo',sans-serif",
};

export const resultLabelStyle = {
  fontSize: 13,
  lineHeight: "20px",
  fontWeight: 600,
  color: "#1f1f1f",
  fontFamily: "'Archivo',sans-serif",
};

export const tabelResultStyle = {
  fontSize: 13,
  lineHeight: "20px",
  fontWeight: 500,
  color: "#1f1f1f",
  fontFamily: "'Archivo',sans-serif",
};

export const paragraphStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.08px",
  textAlign: "start",
};
